document.addEventListener('DOMContentLoaded', function () {
  const wishlistKey = 'customWishlist';

  const emptyHeart = `
  
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-heart"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
  `;

  const filledHeart = `
  
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-heart"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
  `;

  function getWishlist() {
    return JSON.parse(localStorage.getItem(wishlistKey)) || [];
  }

  function saveWishlist(items) {
    localStorage.setItem(wishlistKey, JSON.stringify(items));
  }

  function updateButtons() {
    const wishlist = getWishlist();

    document.querySelectorAll('.wishlist-btn').forEach(button => {
      const handle = button.dataset.productHandle;
      const exists = wishlist.includes(handle);

      button.classList.toggle('active', exists);
      button.innerHTML = exists ? filledHeart : emptyHeart;
    });
  }

  document.querySelectorAll('.wishlist-btn').forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      let wishlist = getWishlist();
      const handle = button.dataset.productHandle;
      const exists = wishlist.includes(handle);

      if (exists) {
        wishlist = wishlist.filter(item => item !== handle);

        const wishlistCard = button.closest('.grid__item');
        if (wishlistCard && document.querySelector('#wishlist-products')) {
          wishlistCard.remove();
        }
      } else {
        wishlist.push(handle);
      }

      saveWishlist(wishlist);
      updateButtons();
    });
  });

  updateButtons();

  const wishlistContainer = document.querySelector('#wishlist-products');
  if (!wishlistContainer) return;

  const wishlist = getWishlist();

  if (wishlist.length === 0) {
    wishlistContainer.innerHTML = `
      <div class="wishlist-empty">
        Your wishlist is empty.
      </div>
    `;
    return;
  }

  wishlist.forEach(handle => {
    fetch(`/products/${handle}?section_id=wishlist-card`)
      .then(response => response.text())
      .then(html => {
        const div = document.createElement('div');
        div.innerHTML = html;

        const item = div.querySelector('.grid__item');

        if (item) {
          wishlistContainer.appendChild(item);
        }
      });
  });
});